<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>
        Validación de Política {{ politica.nombre }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="evaluarPolitica">
        <v-icon>update</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="text-xs-center">
      <v-progress-linear v-show="loading" indeterminate></v-progress-linear>
    </div>
    <v-card-text>
      <template v-if="parametrosModificados">
        <v-layout>
          <v-flex xs12>
            <v-chip small color="yellow"
              >Valores de carga modificados. Re-evaluar la Política.</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <!-- {{ politica }} -->
      <template v-if="politica.restringeCapital == true">
        <v-layout>
          <v-flex xs9>
            Capital Entre $ {{ politica.capitalDesde }} y $
            {{ politica.capitalHasta }}
          </v-flex>
          <v-flex xs3>
            <v-chip small color="gray" v-if="resultadoValidacionCapital == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip small color="green" v-if="resultadoValidacionCapital == 1"
              >Pasó</v-chip
            >
            <v-chip small color="red" v-if="resultadoValidacionCapital == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.restringeEdad == true">
        <v-layout>
          <v-flex xs9>
            Edad Entre {{ politica.edadDesde }} y {{ politica.edadHasta }} años
          </v-flex>
          <v-flex xs3>
            <v-chip small color="gray" v-if="resultadoValidacionEdad == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip small color="green" v-if="resultadoValidacionEdad == 1"
              >Pasó</v-chip
            >
            <v-chip small color="red" v-if="resultadoValidacionEdad == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.relacionCuotaSueldo > 0">
        <v-layout>
          <v-flex xs9>
            Relación Cuota/Sueldo menor a {{ politica.relacionCuotaSueldo }} %
          </v-flex>
          <v-flex xs3>
            <v-chip
              small
              color="gray"
              v-if="resultadoValidacionRelacionCuotaSueldo == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip
              small
              color="green"
              v-if="resultadoValidacionRelacionCuotaSueldo == 1"
              >Pasó</v-chip
            >
            <v-chip
              small
              color="red"
              v-if="resultadoValidacionRelacionCuotaSueldo == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.requiereDomicilioCompleto > 0">
        <v-layout>
          <v-flex xs9> Domicilio Completo </v-flex>
          <v-flex xs3>
            <v-chip small color="gray" v-if="resultadoValidacionDomicilios == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip
              small
              color="green"
              v-if="resultadoValidacionDomicilios == 1"
              >Pasó</v-chip
            >
            <v-chip small color="red" v-if="resultadoValidacionDomicilios == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.requiereDomicilioCompletoSinCP > 0">
        <v-layout>
          <v-flex xs9> Domicilio Completo (Sin CP) </v-flex>
          <v-flex xs3>
            <v-chip small color="gray" v-if="resultadoValidacionDomicilios == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip
              small
              color="green"
              v-if="resultadoValidacionDomicilios == 1"
              >Pasó</v-chip
            >
            <v-chip small color="red" v-if="resultadoValidacionDomicilios == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.requiereCantidadTelefonos > 0">
        <v-layout>
          <v-flex xs9> Cantidad de Teléfonos </v-flex>
          <v-flex xs3>
            <v-chip small color="gray" v-if="resultadoValidacionTelefonos == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip small color="green" v-if="resultadoValidacionTelefonos == 1"
              >Pasó</v-chip
            >
            <v-chip small color="red" v-if="resultadoValidacionTelefonos == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.requiereDatosBancarios > 0">
        <v-layout>
          <v-flex xs9> Datos Bancarios Cargados </v-flex>
          <v-flex xs3>
            <v-chip
              small
              color="gray"
              v-if="resultadoValidacionDatosBancarios == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip
              small
              color="green"
              v-if="resultadoValidacionDatosBancarios == 1"
              >Pasó</v-chip
            >
            <v-chip
              small
              color="red"
              v-if="resultadoValidacionDatosBancarios == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.requiereDebitoEnCuenta > 0">
        <v-layout>
          <v-flex xs9> Débito en Cuenta </v-flex>
          <v-flex xs3>
            <v-chip
              small
              color="gray"
              v-if="resultadoValidacionDebitoEnCuenta == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip
              small
              color="green"
              v-if="resultadoValidacionDebitoEnCuenta == 1"
              >Pasó</v-chip
            >
            <v-chip
              small
              color="red"
              v-if="resultadoValidacionDebitoEnCuenta == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.requiereDatosTarjeta > 0">
        <v-layout>
          <v-flex xs9> Datos de Tarjeta Cargados </v-flex>
          <v-flex xs3>
            <v-chip
              small
              color="gray"
              v-if="resultadoValidacionDatosTarjeta == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip
              small
              color="green"
              v-if="resultadoValidacionDatosTarjeta == 1"
              >Pasó</v-chip
            >
            <v-chip
              small
              color="red"
              v-if="resultadoValidacionDatosTarjeta == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <template v-if="politica.requiereDebitoEnTarjeta > 0">
        <v-layout>
          <v-flex xs9> Débito en Tarjeta </v-flex>
          <v-flex xs3>
            <v-chip
              small
              color="gray"
              v-if="resultadoValidacionDebitoEnTarjeta == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip
              small
              color="green"
              v-if="resultadoValidacionDebitoEnTarjeta == 1"
              >Pasó</v-chip
            >
            <v-chip
              small
              color="red"
              v-if="resultadoValidacionDebitoEnTarjeta == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
      <!-- DATOS CELULAR -->
      <template v-if="politica.requiereDatosCelular > 0">
        <v-layout>
          <v-flex xs9> Datos Celular </v-flex>
          <v-flex xs3>
            <v-chip
              small
              color="gray"
              v-if="resultadoValidacionDatosCelular == 0"
              >Sin Evaluar</v-chip
            >
            <v-chip
              small
              color="green"
              v-if="resultadoValidacionDatosCelular == 1"
              >Pasó</v-chip
            >
            <v-chip
              small
              color="red"
              v-if="resultadoValidacionDatosCelular == 2"
              >Falló</v-chip
            >
          </v-flex>
        </v-layout>
      </template>
    </v-card-text>
    <v-card-actions>
      <app-autorizador
        v-if="!resultadoEvaluacion.resultado.politicaAprobada"
        v-bind:EstaAutorizado.sync="autorizadoPorExcepcion"
        v-bind:MotivoAutoriza.sync="autorizadoPorMotivo"
        v-bind:UsuarioAutoriza.sync="autorizadoPorUsuario">
      </app-autorizador>
    </v-card-actions>
    <v-card v-if="politica.requisitos && politica.requisitos.length > 0">
      <v-card-title>
        <h5>Recuerde que debe presentar</h5>
      </v-card-title>
      <v-card-text>
        <template v-for="item in politica.requisitos">
          <h5>- {{ item }}</h5>
        </template>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import Vue from "vue";

import { mapMutations } from "vuex";

import { http } from "@/axios";

export default {
  data: () => ({
    loading: false,
    parametrosModificados: true,
    autorizadoPorExcepcion: false,
    autorizadoPorUsuario: "",
    autorizadoPorMotivo: "",
    //politica: {nombre: ''},
    resultadoEvaluacion: {
      resultado: {
        politicaAprobada: true,
        resultadoValidacionEdad: { evalado: false, pasoValidacion: false },
      },
    },
  }),
  computed: {
    resultadoValidacionCapital: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionCapitalOtorgado
      );
    },
    resultadoValidacionEdad: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionEdad
      );
    },
    resultadoValidacionRelacionCuotaSueldo: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado
          .resultadoValidacionRelacionCuotaSueldo
      );
    },
    resultadoValidacionDatosBancarios: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionDatosBancarios
      );
    },
    resultadoValidacionDebitoEnCuenta: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionDebitoEnCuenta
      );
    },
    resultadoValidacionDomicilios: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionDomicilios
      );
    },
    resultadoValidacionTelefonos: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionTelefonos
      );
    },
    resultadoValidacionDatosTarjeta: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionDatosTarjeta
      );
    },
    resultadoValidacionDebitoEnTarjeta: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionDebitoEnTarjeta
      );
    },

    resultadoValidacionDatosCelular: function () {
      return this.resultadoValidacionToInt(
        this.resultadoEvaluacion.resultado.resultadoValidacionDatosCelular
      );
    },
  },
  props: {
    ParametrosAValidar: {
      type: Object,
      required: false,
    },
    politica: {
      type: Object,
      required: true,
      default: { id: 0, nombre: "" },
    },
    ValidacionOK: {
      type: Boolean,
      default: false,
    },
    MotivosRechazo: {
      type: String,
      default: "",
    },
    PoliticaAprobada: {
      type: Boolean,
      default: false,
    },
    ErroresPolitica: {
      type: String,
      default: "",
    },
    AutorizadoPorExcepcion: {
      type: Boolean,
    },
    AutorizadoPorUsuario: {
      type: String,
    },
    AutorizadoPorMotivo: {
      type: String,
    },
  },
  watch: {
    autorizadoPorExcepcion: function () {
      this.$emit("update:PoliticaAprobada", true);

      this.$emit("update:AutorizadoPorExcepcion", true);
      this.$emit("update:AutorizadoPorUsuario", this.autorizadoPorUsuario);
      this.$emit("update:AutorizadoPorMotivo", this.autorizadoPorMotivo);
    },
    politica: function () {
      this.parametrosModificados = true;
      this.$emit("update:PoliticaAprobada", false);
      this.$emit(
        "update:ErroresPolitica",
        "Valores de carga modificados. Debe re-evaluar la Política."
      );
    },
    "ParametrosAValidar.capital": {
      handler() {
        if (this.politica.restringeCapital) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
    },
    "ParametrosAValidar.fechaNacimiento": {
      handler() {
        if (this.politica.restringeEdad) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
    },
    "ParametrosAValidar.importeCuota": {
      handler() {
        if (this.politica.restringeRelacionCuotaSueldo) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
    },
    "ParametrosAValidar.ingresoMensual": {
      handler() {
        if (this.politica.restringeRelacionCuotaSueldo) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
    },
    "ParametrosAValidar.cuentaDebito": {
      handler() {
        if (this.politica.requiereDatosBancarios) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
      deep: true,
    },
    "ParametrosAValidar.debitoEnCuenta": {
      handler() {
        if (this.politica.requiereDebitoEnCuenta) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
      deep: true,
    },
    "ParametrosAValidar.telefonos": {
      handler() {
        if (this.politica.requiereCantidadTelefonos) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
    },
    "ParametrosAValidar.domicilios": {
      handler() {
        if (
          this.politica.requiereDomicilioCompleto ||
          this.politica.requiereDomicilioCompletoSinCP
        ) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
    },
    "ParametrosAValidar.solicitaDebitoATarjeta": {
      handler() {
        if (this.politica.requiereDatosTarjeta) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
    },
    "ParametrosAValidar.debitoEnTarjeta": {
      handler() {
        if (this.politica.requiereDebitoEnTarjeta) {
          this.parametrosModificados = true;
          this.$emit("update:PoliticaAprobada", false);
          this.$emit(
            "update:ErroresPolitica",
            "Valores de carga modificados. Debe re-evaluar la Política."
          );
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    resultadoValidacionToInt(resultado) {
      if (resultado && resultado.evaluado)
        if (resultado.pasoValidacion) return 1;
        else return 2;
      else return 0;
    },
    domicilio2Params(domicilio) {
      if (domicilio) {
        return (
          "&calle=" +
          domicilio.calle +
          "&numero=" +
          domicilio.numero +
          "&localidad=" +
          domicilio.localidad +
          "&codigoPostal=" +
          domicilio.codigoPostal +
          "&provincia=" +
          domicilio.provincia
        );
      } else {
        return "";
      }
    },
    async evaluarPolitica() {
      if (this.politica.id == 0) return;

      console.log(this.politica);
      console.log(this.ParametrosAValidar);

      this.loading = true;
      try {
        var result = await http.get(
          "BusinessCore/evaluarpoliticacomercial" +
            "?politicaComercialId=" +
            this.politica.id +
            "&calificacionPersonaId=" +
            this.ParametrosAValidar.calificacionPersonaId +
            "&empresaId=" +
            this.ParametrosAValidar.empresaId +
            "&canalVentaId=" +
            this.ParametrosAValidar.canalVentaId +
            "&planId=" +
            this.ParametrosAValidar.planId +
            "&diaCobroId=" +
            +this.ParametrosAValidar.diaCobroId +
            "&capital=" +
            this.ParametrosAValidar.capital +
            "&importeCuota=" +
            this.ParametrosAValidar.importeCuota +
            "&cantidadCuotas=" +
            this.ParametrosAValidar.cuotas +
            "&fechaCarga=" +
            this.ParametrosAValidar.fechaCarga +
            "&fechaNacimiento=" +
            this.ParametrosAValidar.personaDto.fechaNacimiento +
            "&ingresoMensual=" +
            this.ParametrosAValidar.personaDto.empleo.ingresoNeto +
            "&cbu=" +
            (this.ParametrosAValidar.cuentaDebito
              ? this.ParametrosAValidar.cuentaDebito.cbu
              : "") +
            "&cantidadTelefonos=" +
            this.ParametrosAValidar.personaDto.datosContacto.telefonos.length +
            this.domicilio2Params(
              this.ParametrosAValidar.personaDto.domicilios[0]
            ) +
            "&tieneDebitoEnCuenta=" +
            this.ParametrosAValidar.solicitaDebito +
            "&tieneDatosTarjeta=" +
            (this.ParametrosAValidar.solicitaDebitoATarjeta &&
              (this.ParametrosAValidar.tarjetaDebito.numero != undefined ||
                this.ParametrosAValidar.tarjetaDebito.tarjetaId != undefined ||
                this.ParametrosAValidar.tarjetaDebito.token != undefined)) +
            "&tieneDebitoEnTarjeta=" +
            (this.ParametrosAValidar.tarjetaDebito &&
            this.ParametrosAValidar.tarjetaDebito.activa
              ? this.ParametrosAValidar.tarjetaDebito.activa
              : false) +
            "&modelo=" +
            (this.ParametrosAValidar.modelo !== undefined &&
            this.ParametrosAValidar.modelo !== null
              ? this.ParametrosAValidar.modelo
              : 0) +
            "&imei=" +
            (this.ParametrosAValidar.imei !== undefined &&
            this.ParametrosAValidar.imei !== null
              ? this.ParametrosAValidar.imei
              : 0)
        );
        console.log(result);

        this.parametrosModificados = false;
        this.resultadoEvaluacion = result;

        this.$emit(
          "update:PoliticaAprobada",
          this.resultadoEvaluacion.resultado.politicaAprobada
        );
        this.$emit(
          "update:ErroresPolitica",
          this.resultadoEvaluacion.resultado.motivosRechazo
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
